import {Navigate, Route, Routes, useLocation} from "react-router";
import {AuthLayout} from "./layouts/AuthLayout";
import {AppLayout} from "./layouts/AppLayout";
import {AdminLayout} from "./layouts/AdminLayout";
import {LoginContainer} from "./containers/Login";
import {DashboardContainer} from "./containers/Dashboard";
import {AuditContainer} from "./containers/Audit";
import {ProfitDriversContainer} from "./containers/ProfitDrivers";
import {ProfitLeaksContainer} from "./containers/ProfitLeaks";
import {OptimizeContainer} from "./containers/Optimize";
import {ActivateContainer} from "./containers/Activate";
import {ReportsContainer} from "./containers/Reports";
import {WaterfallContainer} from "./containers/Waterfall";
import {KpiPerformanceDetailContainer} from "./containers/KpiPerformanceDetail";
import {OpportunityContainer} from "./containers/AuditOpportunity";
import {AuditProfileContainer} from "./containers/AuditProfile";
import {AuditTrendsContainer} from "./containers/AuditTrends";
import {SegmentationContainer} from "./containers/Segmentation";
import {CustomerHealthContainer} from "./containers/CustomerHealth";
import {CustomerHealthSignalsContainer} from "./containers/CustomerHealthSignals";
import {AdminContainer} from "./containers/Admin";
import {AlertsPanel} from "./containers/AlertsPanel";
import {SettingsContainer} from "./containers/Settings";

export const App = () => {
    return (
        <div>
            <Routes>
                <Route element={<AuthLayout/>}>
                    <Route index element={<LoginContainer/>}/>
                </Route>
                <Route element={<AppLayout/>}>
                    <Route path="dashboard" element={<DashboardContainer/>}/>
                    <Route path="audit" element={<AuditContainer/>}>
                        <Route path="profile" element={<AuditProfileContainer/>}/>
                        <Route path="trends" element={<AuditTrendsContainer/>}/>
                        <Route path="drivers" element={<ProfitDriversContainer/>}/>
                        <Route path="leaks" element={<ProfitLeaksContainer/>}/>
                        <Route path="opportunity" element={<OpportunityContainer/>}/>
                        <Route path="segmentation" element={<SegmentationContainer/>}/>
                        <Route path="customer-churn" element={<CustomerHealthContainer/>}/>
                        <Route path="customer-health" element={<CustomerHealthSignalsContainer/>}/>
                    </Route>
                    <Route path="optimize" element={<OptimizeContainer/>}/>
                    <Route path="activate" element={<ActivateContainer/>}/>
                    <Route path="reports" element={<ReportsContainer/>}>
                        <Route path="waterfall" element={<WaterfallContainer/>}/>
                        <Route path="kpi" element={<KpiPerformanceDetailContainer/>}/>
                    </Route>
                    <Route path="alerts" element={<AlertsPanel/>} />
                    <Route path="settings" element={<SettingsContainer/>} />
                    <Route element={<AdminLayout/>}>
                        <Route path="admin" element={<AdminContainer/>}/>
                    </Route>
                </Route>
            </Routes>
        </div>
    );
};